import { Injectable, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { Constants } from './models/constants';
import PouchDB from 'pouchdb';
import { StorePouchDb } from '../store/store.pouchdb.service';
import PouchdbFind from 'pouchdb-find';

import { Http, Response, RequestOptions, Headers, RequestOptionsArgs } from '@angular/http';
import { forEach } from '@angular/router/src/utils/collection';

declare var FilePicker: any;
declare var google;
declare var gapi: any;
declare var MediaUploader: any;
@Injectable()

export class GoogleService {
  public fsdata = [];
  storedata = [];
  googlechilderen: any;
  GoogledriveData;
  // userGoogleDriveId;
  godata;
  imagedata;
  videodata;
  filteredData = [];
  sheetdata;
  docudata;
  audiodata;
  pptdata;
  localDB;
  remoteDB;

  ShareList;
  constructor(public pouchservice: StorePouchDb, private http: Http) {
    PouchDB.plugin(PouchdbFind);
  }

  ngOnInit() {
    ;

  }

  GetContactList(that) {

    this.localDB = this.pouchservice.localDB;
    this.remoteDB = this.pouchservice.remoteDB;
    var self = this;
    // this.localDB.replicate.from(this.remoteDB);
    // this.pouchservice.loadPouchDb();


    const headers = new Headers();
    headers.append('Authorization', 'Bearer' + localStorage.userToken);
    const options = new RequestOptions({ headers: headers });
    var self = this;

    this.http.post(
      "http://"+Constants.nasUrl, {
        "query": 'query{ appPremissions, {directExport, organizationId, appFeatures,{ id, featuresType}contacts{user, { id, name, type, email }} }}',
      }, options
    ).subscribe(
      res =>
        self.GetContactListshare(res.json().data, that)
      //this.ShareList= contact.appPremissions.contacts
    );


  }
  GetContactListshare(contact, that) {
    that.getcontact(contact)

  }
  Getgoogledrive(self) {

    let that = this;
    if (gapi.client.drive) {
      var request = gapi.client.drive.files.list({

      });
      request.execute(function (resp) {
        if (!resp.error) {
          that.godata = resp.items;
          that.GoogledriveData = resp.items
          try { self.getAllFolderData(that.GoogledriveData); }
          catch (ex) {

          }

        }
      })
    }

  }

  getSpreadSheetGoogleDrive() {
    let that = this;
    var request = gapi.client.drive.files.list({
      q: "trashed=false and mimeType='application/vnd.google-apps.spreadsheet'"

    });

    return new Promise((resolve, reject) => {
      request.execute(function (resp) {
        if (!resp.error) {
          that.sheetdata = resp.items;
          resolve(that.sheetdata)
        }
      })
    });

  }

  getDocumentsGoogleDrive() {
    let that = this;
    var request = gapi.client.drive.files.list({
      q: "trashed=false and mimeType='application/vnd.google-apps.document'"

    });

    return new Promise((resolve, reject) => {
      request.execute(function (resp) {
        if (!resp.error) {
          that.docudata = resp.items;
          resolve(that.docudata)
        }
      })
    });

  }

  getPresentationsGoogleDrive() {
    let that = this;
    var request = gapi.client.drive.files.list({
      q: "trashed=false and mimeType='application/vnd.google-apps.presentation'"

    });

    return new Promise((resolve, reject) => {
      request.execute(function (resp) {
        if (!resp.error) {
          that.pptdata = resp.items;
          resolve(that.pptdata)
        }
      })
    });

  }


  //   initPicker() {
  //  ;
  //     var picker = new FilePicker({
  //       apiKey: 'AIzaSyDdDVFTVfrlGcjA5O8Lk6aIWLsjTVV1l2c',
  //       clientId: "442582743098-cd71vdhj3jo0rkab4csj14jvcshmat1v.apps.googleusercontent.com",
  //       buttonEl: document.getElementById('pick'),
  //       onSelect: function (file) {
  //         console.log(file);
  //         alert('Selected ' + file.title);
  //       },
  //     });
  //   }

  insertPermission(fileId) {
    var body = {
      'value': 'default',
      'type': 'anyone',
      'role': 'reader'
    };
    var request = gapi.client.drive.permissions.insert({
      'fileId': fileId,
      'resource': body
    });
    request.execute(function (resp) { });
  }

  insertFileintofloder(f, fileData, parentID, callback, self) {
    const boundary = '-------314159265358979323846';
    const delimiter = "\r\n--" + boundary + "\r\n";
    const close_delim = "\r\n--" + boundary + "--";
    var self = self;
    var reader = new FileReader();
    reader.readAsBinaryString(f);
    reader.onload = function (e) {
      var contentType = fileData.type || 'application/octet-stream';
      var metadata = {
        'title': Math.round(new Date().getTime() / 1000),
        'mimeType': contentType,
        'parents': [{ 'id': parentID }]
      };

      var base64Data = btoa(reader.result);
      var multipartRequestBody =
        delimiter +
        'Content-Type: application/json\r\n\r\n' +
        JSON.stringify(metadata) +
        delimiter +
        'Content-Type: ' + contentType + '\r\n' +
        'Content-Transfer-Encoding: base64\r\n' +
        '\r\n' +
        base64Data +
        close_delim;

      var request = gapi.client.request({
        'path': '/upload/drive/v2/files',
        'method': 'POST',
        'params': { 'uploadType': 'multipart' },
        'headers': {
          'Content-Type': 'multipart/mixed; boundary="' + boundary + '"'
        },
        'body': multipartRequestBody
      });
      if (!callback) {
        callback = function (file) {
          //that.insertPermission(file.id);

          if (self.imageAddedIntoDrive) {
            self.imageAddedIntoDrive(file);
          }
          console.log(file)
        };
      }
      request.execute(callback);
    }
  }

  Createfolder(folderName,self) {
    //var userGoogleDriveId = localStorage.userGoogleDriveId;
    // this.getDriveData();
    var body = {
      'title': folderName,
      
      'mimeType': "application/vnd.google-apps.folder"
    };

    var request = gapi.client.drive.files.insert({
      'resource': body
    });

    var self = self;
    request.execute(function (resp) {
      
    });
  }
  permissions
  Sharefile(data, email, emails, roles) {
    let that = this
    if (emails != undefined && emails.length > 0){
      emails.forEach(element => {
        var body = {
          'value': element,
          'type': 'user',
          'role': roles
        };
        var request = gapi.client.drive.permissions.insert({
          'fileId': data,
          'resource': body
        });
        request.execute(function (resp) {
          console.log(resp)
        });
      });
    }    
    else if (email != "" || email != undefined){
      var body = {
        'value': email,
        'type': 'user',
        'role': 'writer'
      };
    var request = gapi.client.drive.permissions.insert({
      'fileId': data,
      'resource': body
    });
    request.execute(function(resp) { 
      console.log(resp)
    });

    }

  }
  insertFileintodrive(f, fileData, parentID, self) {
    let that = this
    const boundary = '-------314159265358979323846';
    const delimiter = "\r\n--" + boundary + "\r\n";
    const close_delim = "\r\n--" + boundary + "--";
    var self = self;
    var reader = new FileReader();
    reader.readAsBinaryString(f);
    reader.onload = function (e) {
      var contentType = fileData.type || 'application/octet-stream';
      var metadata
      if (parentID == undefined) {
        metadata = {
          'title': f.name,
          'mimeType': f.contentType,

        };
      } else {
        metadata = {
          'title': f.name,
          'mimeType': f.contentType,
          'parents': [{ 'id': parentID }]
        };
      }


      var base64Data = btoa(reader.result);
      var multipartRequestBody =
        delimiter +
        'Content-Type: application/json\r\n\r\n' +
        JSON.stringify(metadata) +
        delimiter +
        'Content-Type: ' + contentType + '\r\n' +
        'Content-Transfer-Encoding: base64\r\n' +
        '\r\n' +
        base64Data +
        close_delim;

      var request = gapi.client.request({
        'path': '/upload/drive/v2/files',
        'method': 'POST',
        'params': { 'uploadType': 'multipart' },
        'headers': {
          'Content-Type': 'multipart/mixed; boundary="' + boundary + '"'
        },
        'body': multipartRequestBody
      });

      request.execute(function (resp) {
        that.insertPermission(resp.id)
        try {
          if (parentID == undefined) {
            self.Getfilesdtaledrive(self)
          }
          else {
            self.retrieveAllFilesInFolder(parentID, undefined)
          }
        }
        catch (ex) {

        }
        // try{


        //   self.Createfolderelectron(resp)

        // }
        //  catch(ex) {

        //  }
      });

    }
  }
  Createdrivefolder(folderName, folderId, mycomponent) {
    //var userGoogleDriveId = localStorage.userGoogleDriveId;
    // this.getDriveData();
    var body
    if(folderId==undefined){
      body={
        'title': folderName,
        
        'mimeType': "application/vnd.google-apps.folder"
      }
    }
    else{
       body = {
        'title': folderName,
        'parents': [{ 'id': folderId }],
        'mimeType': "application/vnd.google-apps.folder"
      };
    }
    

    var request = gapi.client.drive.files.insert({
      'resource': body
    });

    var self = this;
    request.execute(function (resp) {
      if(folderId==undefined){
        mycomponent.Getfolderdtaledrive(mycomponent)
      }
      else{
        mycomponent.retrieveAllFilesInFolder(folderId,undefined)
      }
     
    });
  }
  CreateMediafolder(folderName,folderId) {
    //var userGoogleDriveId = localStorage.userGoogleDriveId;
    // this.getDriveData();
    var body = {
      'title': folderName,
      'parents': [{ 'id': folderId }],
      'mimeType': "application/vnd.google-apps.folder"
    };

    var request = gapi.client.drive.files.insert({
      'resource': body
    });

    var self = this;
    request.execute(function (resp) {
      self.insertProperty(resp.id,Constants.nooorMediaFolderId);
      localStorage.currentDriveMediaId =self.getmyfile(Constants.nooorMediaFolderId);
    });
  }

  CreateNooorfolder(folderName) {
    // this.getDriveData();
    var body = {
      'title': folderName,
      'mimeType': "application/vnd.google-apps.folder"
    };

    var request = gapi.client.drive.files.insert({
      'resource': body
    });

    
    var self = this;
    request.execute(function (resp) {
      
      self.insertProperty(resp.id,Constants.nooorFolderId);
      
      self.CreateMediafolder('Media',resp.id);
      
    });

   

  }


  insertFile(f, files, that) {
    for (var i = 0, f; f = files[i]; i++) {
      var uploader = new MediaUploader({
        file: f,
        token: gapi.auth.getToken().access_token,
        onComplete: function (data) {
          console.log(data)
        }
      });
      uploader.upload();
    }
  }
  foldersdata() {

    if (this.googlechilderen != undefined) {

      this.storedata = [];
      let tempData = [];
      for (let i = 0; i < this.googlechilderen.length; i++) {
        for (let j = 0; j < this.GoogledriveData.length; j++) {
          if (this.googlechilderen[i].id == this.GoogledriveData[j].id) {
            tempData.push(this.GoogledriveData[j]);
          }
        }
      }
      this.storedata = tempData;
    }
  }

  retrieveAllFilesInFolder(folderId, self, type) {
    folderId = localStorage.currentDriveMediaId

    var retrievePageOfChildren = function (request, result, that) {
      let cloudFolderData;
      request.execute(function (resp) {
        result = result.concat(resp.items);

        that.googlechilderen = result;
        if (result.length && !resp.error) {
          that.googlechilderen.forEach(function (_data) {
            _data.embedLink = _data.iconLink.replace(/16/g, 128)
          })
        }
        if (type == "image") {
          cloudFolderData = _.filter(that.googlechilderen, function (o) { return (o.mimeType == "image/jpeg" || o.mimeType == "image/png") && o.labels.trashed == false; });
        } else if (type == "video") {
          cloudFolderData = _.filter(that.googlechilderen, function (o) { return (o.mimeType == "video/mp4" || o.mimeType == "video/quicktime") && o.labels.trashed == false; });
        } else if (type == "audio") {
          cloudFolderData = _.filter(that.googlechilderen, function (o) { return o.mimeType == "audio/mpeg" && o.labels.trashed == false; });
        }
        self.getAllCloudFloderData(cloudFolderData);
        var nextPageToken = resp.nextPageToken;
        if (nextPageToken) {
          request = gapi.client.drive.files.list({

            'pageToken': nextPageToken
          });
          retrievePageOfChildren(request, result, this);
        } else {
          //  callback(result);
        }
      });
    }
    var initialRequest = gapi.client.drive.files.list({
      q: "'" + folderId + "' in parents",

    });

    retrievePageOfChildren(initialRequest, [], this);


  }

  insertProperty(fileId,value) {
    let that=this
    var body = {
      'key': 'myID',
      'value': value,
      'visibility': 'public'
    }
    var request = gapi.client.drive.properties.insert({
      'fileId': fileId,
      'resource': body
    });
    request.execute(function(resp) {
     
     });
  }


  getmyfile(folderId){

    var request = gapi.client.drive.files.list({
      q: "properties has { key='myID' and value='"+folderId+"' and visibility='public' }"
    });
    var r
    let error = false;
    return new Promise((resolve, reject) => {
      request.execute(function (resp) {
        if (!resp.error) {
          r = resp.items;
          var userId = undefined;
          if (resp.items.length > 0) {
            userId = resp.items[0].id;
          }


          resolve(userId)
        }
      })
    });


  }

  getDriveData(id) {
    var request = gapi.client.drive.files.list({
    });
    var r
    let error = false;
    return new Promise((resolve, reject) => {
      request.execute(function (resp) {
        if (!resp.error) {
          r = resp.items;
          var a = _.find(resp.items, function (o) {
            return o.id === id;
          })
          resolve(a)
        }
      })
    });
  }

  // Getimagegoogledrive(self) {
  //   let that = this;
  //   var request = gapi.client.drive.files.list({
  //     q: "(mimeType='image/jpeg' or mimeType='image/png') and trashed=false"
  //   });
  //   request.execute(function (resp) {
  //     if (!resp.error) {

  //       that.imagedata = resp.items;
  //       //that.GoogledriveData = resp.items
  //       self.getAllImageData(that.imagedata);
  //     }
  //   })

  //   return (that.imagedata)
  // }


  // Getvideogoogledrive(self) {
  //   let that = this;
  //   var request = gapi.client.drive.files.list({
  //     q: "(mimeType='video/quicktime' or mimeType='video/mp4' or mimeType='video/x-ms-wmv') and trashed=false"
  //   });
  //   request.execute(function (resp) {
  //     if (!resp.error) {

  //       that.videodata = resp.items;
  //       //that.GoogledriveData = resp.items
  //       self.getAllVideoData(that.videodata);
  //     }
  //   })

  //   return (that.videodata)
  // }

  // GetAudiogoogledrive(self) {
  //   let that = this;
  //   var request = gapi.client.drive.files.list({
  //     q: "(mimeType='audio/mpeg' or mimeType='audio/mp3') and trashed=false"

  //   });
  //   request.execute(function (resp) {
  //     if (!resp.error) {

  //       that.audiodata = resp.items;
  //       //that.GoogledriveData = resp.items
  //       self.getAllAudioData(that.audiodata);
  //     }
  //   })

  //   return (that.sheetdata)
  // }

  async GetGoogleDriveCloudData(self, type) {
    let folderId = localStorage.currentDriveMediaId;
    let filterCData: any = [];
    var GoogledriveAllData;
    var googlechilderen;
    let that = this;
    if (gapi.client.drive) {
      var request = gapi.client.drive.files.list({
      });
      request.execute(function (resp) {
        if (!resp.error) {
          GoogledriveAllData = resp.items
          var retrievePageOfChildren = function (request, result, that) {
            request.execute(function (resp) {
              result = result.concat(resp.items);
              googlechilderen = result;
              var folderid = _.map(googlechilderen, 'id')
              var driveid = _.map(GoogledriveAllData, 'id')
              var mydata = _.difference(driveid, folderid);
              GoogledriveAllData.filter(function (newData) {
                return mydata.filter(function (oldData) {
                  if (newData.id === oldData) {
                    filterCData.push(newData)
                  }
                })
              });
              let cloudFilterImageData;
              if (type == "image") {
                cloudFilterImageData = _.filter(filterCData, function (o) { return (o.mimeType == "image/jpeg" || o.mimeType == "image/png") && o.labels.trashed == false; });
                self.getAllImageData(cloudFilterImageData);
              } else if (type == "video") {
                cloudFilterImageData = _.filter(filterCData, function (o) { return (o.mimeType == "video/mp4" || o.mimeType == "video/quicktime" || o.mimeType == "video/x-ms-wmv") && o.labels.trashed == false; });
                self.getAllVideoData(cloudFilterImageData);
              } else if (type == "audio") {
                cloudFilterImageData = _.filter(filterCData, function (o) { return o.mimeType == "audio/mpeg" || o.mimeType == "audio/mp3" && o.labels.trashed == false; });
                self.getAllAudioData(cloudFilterImageData);
              }
              // console.log(cloudFilterImageData);
              var nextPageToken = resp.nextPageToken;
              if (nextPageToken) {
                request = gapi.client.drive.files.list({
                  'pageToken': nextPageToken
                });
                retrievePageOfChildren(request, result, this);
              } else {
              }
            });
          }

          var initialRequest = gapi.client.drive.files.list({
            q: "'" + folderId + "' in parents",
          });
          retrievePageOfChildren(initialRequest, [], this);

        }
      })
    }

  }


}


// WEBPACK FOOTER //
// ./src/app/shared/Google.service.ts